import React from "react";
import BannerSectionDesktop from "./BannerSectionDesktop/BannerSection";
import BannerSectionMobile from "./BannerSectionMobile/BannerSection";
import { BannerSectionProps } from "@/app/interface/components";

const BannerSection: React.FC<BannerSectionProps> = (props) => {
  return (
    <>
      <div className="max-lg:hidden">
        <BannerSectionDesktop {...props} />
      </div>
      <div className="lg:hidden">
        <BannerSectionMobile {...props} />
      </div>
    </>
  );
};

export default React.memo(BannerSection);
